<template>
    <div>
        <h3 class="mb-3 text-[13px] font-medium text-theme-text">
            {{ localizations[lang].typography }}
        </h3>
        <div class="flex flex-wrap gap-2">
            <SettingsButton
                v-for="font in fontOptions"
                :key="font.id"
                variant="pill"
                :is-active="selectedFont?.id === font.id"
                :style="{ fontFamily: font.cssStack }"
                @click="selectFont(font)"
            >
                {{ font.labelKey ? localizations[lang][font.labelKey] : font.label }}
            </SettingsButton>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ACCESSIBLE_FONTS, findFontByValue } from '../../../js/utils/accessibleFonts';
import SettingsButton from './SettingsButton.vue';

export default {
    name: 'FontSelector',
    components: {
        SettingsButton,
    },
    computed: {
        ...mapState(['localizations', 'lang', 'userSettings']),

        fontOptions() {
            return ACCESSIBLE_FONTS;
        },

        selectedFont() {
            return findFontByValue(this.userSettings.epub.fontFamily) || ACCESSIBLE_FONTS[0];
        },
    },
    methods: {
        ...mapActions(['updateUserSettings']),

        selectFont(font) {
            this.$bus.$emit('fontFamily', font.value);
            this.updateUserSettings({ fontFamily: font.value });
        },
    },
};
</script>
